(() => {
  "use strict";
  // Davines professional litre sizes are sold by direct link only.
  const njPrivateDavinesLiter = p => {
    const variants = Array.isArray(p?.variants) ? p.variants : (p?.variants?.nodes || []);
    const text = [p?.title, p?.handle, ...variants.map(v => v?.title || '')]
      .join(' ').replace(/[-_]/g, ' ');
    return /davines/i.test(String(p?.vendor || '') + ' ' + text) &&
      /(?:^|[^\d])(?:1\s*(?:l|litros?)\b|1[.,]000\s*ml\b|1000\s*ml\b|litros?\b)/i.test(text);
  };
  const rootPath = window.Shopify?.routes?.root || "/";
  const root = rootPath.endsWith("/") ? rootPath : rootPath + "/";
  const curated = window.NJProductPairs || {};
  const formatCurrency = (amount, currency) => {
    try { return new Intl.NumberFormat("es-ES", { style: "currency", currency: currency || window.Shopify?.currency?.active || "EUR" }).format(amount / 100); }
    catch (_) { return (amount / 100).toFixed(2) + " €"; }
  };
  async function json(url, options) {
    const r = await fetch(url, options || { headers: { Accept: "application/json" } });
    if (!r.ok) throw new Error("No se pudo consultar el producto");
    return r.json();
  }
  const available = p => !!(p && p.available && Number(p.price) > 0 && p.handle && Array.isArray(p.variants) && p.variants.some(v => v.available));
  // QA: never propose gifts, service bookings, free internal incentives or unpublished items.
  const sellable = p => available(p) && !njPrivateDavinesLiter(p) &&
    !/^(🎁|muestra\b|sample\b)/i.test(String(p.title || "").trim()) &&
    !/^(NOELIA JIMENEZ|NOELIA JIMÉNEZ|INCENTIVO COMPRA)$/i.test(String(p.vendor || "").trim()) &&
    !/(?:^|\b)(?:servicios?|bonos?|manicura|pedicura|indiba|microneedling|tratamiento facial|presoterapia)(?:\b|$)/i.test(String(p.type || ""));
  const kind = p => {
    const s = (String(p?.type || "") + " " + String(p?.title || "")).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    if (/\b(?:pack|cofre|kit|set|duo|rutina)\b/.test(s)) return "bundle";
    if (/champu|shampoo|shampooing/.test(s)) return "shampoo";
    if (/acondicionador|conditioner/.test(s)) return "conditioner";
    if (/mascarilla|masque|hair mask|hair butter/.test(s) && /cabell|hair|capilar|davines|oribe|wella/.test(s)) return "hairmask";
    if (/cuero cabelludo|scalp|capilar|styling|peinado|spray capilar|hair/.test(s)) return "haircare";
    if (/crema facial|face cream|hidratante facial|moisturizer|contorno de ojos/.test(s)) return "facecream";
    if (/serum facial|serum |serum de noche|retinal|retinol|vitamina c|peptid/.test(s)) return "faceserum";
    if (/limpiador facial|leche limpiadora|cleanser|tonico|facial foam|lait/.test(s)) return "facecleanser";
    if (/protector solar|sunscreen|spf ?[235]/.test(s)) return "sunscreen";
    return "";
  };
  const complementScore = (base, p) => {
    const b = kind(base), t = kind(p);
    const preferred = {shampoo:["conditioner","hairmask"],conditioner:["shampoo","hairmask"],
      hairmask:["shampoo","conditioner"],facecream:["faceserum","sunscreen"],
      faceserum:["facecream","sunscreen"],facecleanser:["facecream","faceserum"],
      sunscreen:["facecream","faceserum"],haircare:["shampoo","conditioner"]};
    const match = (preferred[b] || []).includes(t) ? 100 : 0;
    const sameVendor = String(base.vendor || "").toLowerCase() === String(p.vendor || "").toLowerCase() ? 15 : 0;
    return match + sameVendor;
  };
  const asset = p => {
    const v = p.featured_image || p.images?.[0];
    const u = typeof v === "object" ? v?.src : v;
    return typeof u === "string" && /^(https?:)?\/\//.test(u) ? u : null;
  };
  const productUrl = p => root + "products/" + encodeURIComponent(p.handle);
  const formFor = el => document.getElementById(el.dataset.productFormId);
  function selectedVariant(form, base) {
    const idElement = form?.querySelector('input[name="id"], select[name="id"]');
    const id = String(idElement?.value || "");
    return (base.variants || []).find(v => String(v.id) === id) ||
      (base.variants.length === 1 ? base.variants[0] : null);
  }
  function quantity(form) {
    const n = Number.parseInt(form?.querySelector('[name="quantity"]')?.value || "1", 10);
    return Number.isSafeInteger(n) && n >= 1 && n <= 99 ? n : 1;
  }
  function recalc(el, base, products) {
    const form = formFor(el);
    const variant = selectedVariant(form, base);
    const qty = quantity(form);
    const chosen = products.filter(p => el.querySelector('input[data-nj-check="' + p.handle + '"]')?.checked);
    const total = (variant?.available ? Number(variant.price) * qty : 0) +
      chosen.reduce((sum, p) => sum + Number(p.variants[0].price), 0);
    const totalNode = el.querySelector("[data-nj-routine-total]");
    if (totalNode) totalNode.textContent = variant?.available ? formatCurrency(total) : "Selecciona un formato";
    const baseNode = el.querySelector("[data-nj-routine-base]");
    if (baseNode) {
      const label = qty === 1 ? "Tu producto" : "Tus " + qty + " unidades";
      baseNode.textContent = label + ": " + base.title + (variant?.available ? " · " + formatCurrency(Number(variant.price) * qty) : "");
    }
    const selectedForSave = variant?.available ? [
      { handle: base.handle, variantId: Number(variant.id), quantity: qty },
      ...chosen.map(p => ({ handle: p.handle, variantId: Number(p.variants[0].id), quantity: 1 }))
    ] : [];
    el.dataset.njCurrentSelection = JSON.stringify(selectedForSave);
    const btn = el.querySelector("[data-nj-routine-add]");
    if (btn && !btn.dataset.busy) btn.disabled = !(variant?.available && chosen.length > 0);
    if (btn) btn.textContent = chosen.length > 0 ? "Añadir " + (chosen.length + qty) + " productos al carrito" : "Selecciona al menos un complemento";
    return { variant, qty, chosen };
  }
  function render(el, base, choices, mode) {
    const list = el.querySelector("[data-nj-routine-list]");
    const title = el.querySelector("[data-nj-routine-heading]");
    if (!list || !title || !choices.length) return;
    title.textContent = mode === "related" ? "Otros productos que pueden interesarte" : "Completa tu ritual";
    const eyebrow = el.querySelector(".nj-routine__eyebrow");
    if (eyebrow) eyebrow.textContent = mode === "editorial" ? "La selección profesional de Noelia" : "Sugerencias que combinan contigo";
    for (const p of choices.slice(0, 2)) {
      const row = document.createElement("div");
      row.className = "nj-routine__card";
      const canAdd = p.variants.length === 1 && p.variants[0].available;
      if (canAdd) {
        const check = document.createElement("input");
        check.type = "checkbox";
        check.checked = true;
        check.setAttribute("aria-label", "Añadir " + p.title);
        check.setAttribute("data-nj-check", p.handle);
        row.append(check);
      } else {
        const blank = document.createElement("span");
        row.append(blank);
      }
      const imgHref = document.createElement("a"); imgHref.href = productUrl(p);
      const imageUrl = asset(p);
      if (imageUrl) {
        const img = document.createElement("img"); img.src = imageUrl; img.alt = p.title; img.loading = "lazy";
        imgHref.append(img);
      }
      row.append(imgHref);
      const desc = document.createElement("div"); desc.className = "nj-routine__desc";
      const link = document.createElement("a"); link.href = productUrl(p); link.textContent = p.title; desc.append(link);
      const amount = document.createElement("small"); amount.textContent = canAdd ? formatCurrency(Number(p.variants[0].price)) : "Ver opciones y formatos";
      desc.append(amount); row.append(desc); list.append(row);
    }
    // Only the products with a single, unambiguous variant are selectable for one-click purchase.
    const selectable = choices.slice(0, 2).filter(p => p.variants.length === 1 && p.variants[0].available);
    if (!selectable.length) return;
    const form = formFor(el);
    el.addEventListener("change", () => recalc(el, base, selectable));
    if (form) {
      form.addEventListener("change", () => recalc(el, base, selectable));
      form.addEventListener("input", () => recalc(el, base, selectable));
    }
    const button = el.querySelector("[data-nj-routine-add]");
    const status = el.querySelector("[data-nj-routine-status]");
    button.addEventListener("click", async () => {
      if (button.dataset.busy) return;
      const { variant, qty, chosen } = recalc(el, base, selectable);
      if (!variant?.available || !chosen.length) {
        status.textContent = "Selecciona una variante disponible y al menos un complemento.";
        return;
      }
      if (form && typeof form.reportValidity === "function" && !form.reportValidity()) {
        status.textContent = "Completa primero los campos obligatorios del producto.";
        return;
      }
      const items = [{ id: Number(variant.id), quantity: qty }];
      if (!Number.isSafeInteger(items[0].id)) { status.textContent = "Revisa el formato seleccionado."; return; }
      // Respect custom properties and optional selling plans from the existing product form.
      if (form) {
        const fd = new FormData(form);
        const props = {};
        for (const [k, v] of fd) {
          const m = k.match(/^properties\[(.+)\]$/);
          if (m && typeof v === "string" && v.trim()) props[m[1]] = v;
        }
        if (Object.keys(props).length) items[0].properties = props;
        const plan = String(fd.get("selling_plan") || "");
        if (plan) items[0].selling_plan = Number(plan);
      }
      for (const product of chosen) items.push({ id: Number(product.variants[0].id), quantity: 1, properties: { "_nj_origen": "venta_cruzada_ficha" } });
      button.dataset.busy = "1"; button.disabled = true; button.textContent = "Añadiendo rutina…";
      status.textContent = "";
      try {
        const response = await json(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
        const addedItems = Array.isArray(response?.items) ? response.items : [response];
        const originConfirmedIds = new Set(addedItems.filter(item => item?.properties?._nj_origen === "venta_cruzada_ficha").map(item => String(item.variant_id || item.id || "")));
        const originConfirmedCount = chosen.filter(p => originConfirmedIds.has(String(p.variants[0].id))).length;
        document.dispatchEvent(new CustomEvent("nj:analytics", {detail:{event:"nj_routine_add_success",nj_page:location.pathname,nj_complement_count:chosen.length,nj_origin_confirmed_count:originConfirmedCount,nj_complement_variant_ids:chosen.map(p=>String(p.variants[0].id)),nj_source:"pdp_routine"}}));
        window.location.assign(root + "cart");
      } catch (_) {
        status.textContent = "No se ha podido añadir toda la selección. Revisa el stock o vuelve a intentarlo.";
        delete button.dataset.busy;
        recalc(el, base, selectable);
      }
    });
    el.hidden = false;
    recalc(el, base, selectable);
  }
  async function populate(el) {
    if (el.dataset.njLoaded) return;
    el.dataset.njLoaded = "loading";
    const handle = el.dataset.productHandle, id = el.dataset.productId;
    if (!handle || !/^\d+$/.test(id || "")) return;
    try {
      const base = await json(root + "products/" + encodeURIComponent(handle) + ".js");
      if (!available(base)) return;
      const handles = (curated[handle] || []).slice(0, 5);
      // Editorial pairings first; Search & Discovery provides complementary products elsewhere.
      const editorial = await Promise.all(handles.map(h => json(root + "products/" + encodeURIComponent(h) + ".js").catch(() => null)));
      let choices = editorial.filter(p => sellable(p) && p.handle !== handle);
      let mode = choices.length ? "editorial" : "complementary";
      const native = await json(root + "recommendations/products.json?intent=complementary&limit=6&product_id=" + encodeURIComponent(id)).catch(() => ({ products: [] }));
      const seen = new Set([handle, ...choices.map(p => p.handle)]);
      // Nativas: cuando se reconoce el tipo, exigir compatibilidad real.
      const baseKind = kind(base);
      for (const p of native.products || []) {
        if (!sellable(p) || seen.has(p.handle)) continue;
        const compatible = !baseKind || baseKind === "bundle" || complementScore(base, p) >= 100;
        if (compatible) { choices.push(p); seen.add(p.handle); }
      }
      if (!choices.length) {
        const related = await json(root + "recommendations/products.json?intent=related&limit=6&product_id=" + encodeURIComponent(id)).catch(() => ({ products: [] }));
        choices = (related.products || []).filter(p =>
          sellable(p) && p.handle !== handle &&
          (!baseKind || baseKind === "bundle" || complementScore(base, p) >= 100))
          .sort((a, b) => complementScore(base, b) - complementScore(base, a)).slice(0, 2);
        mode = "related";
      }
      // One-click never assumes the format of a multi-variant complementary item.
      const oneClickChoices = choices.filter(p => p.variants.length === 1 && p.variants[0].available);
      if (el.isConnected && oneClickChoices.length) render(el, base, oneClickChoices, mode);
    } catch (_) {
      // Keep the normal buying experience available if a recommendation cannot be loaded.
    }
  }
  let queued = false;
  function scan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      document.querySelectorAll("[data-nj-pdp-upsell]").forEach(el => {
        if (!el.dataset.njLoaded) populate(el);
      });
    });
  }
  const start = () => {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();
})();